import { API, graphqlOperation } from 'aws-amplify';
import _ from 'lodash';

import logger from 'common/utils/logger';
import store from 'redux/store';
import { updateUserInfo as updateUserInfoMutation, acceptTOC as acceptTOCMutation } from 'graphql/mutations';
import { setUserTOCResults } from 'redux/user/user.actions';
import { viewer } from 'graphql/queries';

const LOGGER_PREFIX = 'UserService';

class UserService {
  getViewer = async () => {
    try {
      logger.debug(`${LOGGER_PREFIX}::getViewer`);
      const result = await API.graphql(graphqlOperation(viewer));
      logger.debug(`${LOGGER_PREFIX}::getViewer result`, result);
      return result;
    } catch (err) {
      logger.error(`${LOGGER_PREFIX}::getViewer`, err);
    }
  };

  updateUserInfo = async () => {
    try {
      logger.debug(`${LOGGER_PREFIX}::updateUserInfo`);
      const result = await API.graphql(graphqlOperation(updateUserInfoMutation));
      logger.debug(`${LOGGER_PREFIX}::updateUserInfo result`, result);
      return result;
    } catch (err) {
      logger.error(`${LOGGER_PREFIX}::updateUserInfo`, err);
    }
  };

  acceptTOC = async () => {
    try {
      logger.debug(`${LOGGER_PREFIX}::acceptTOC`);
      const result = await API.graphql(graphqlOperation(acceptTOCMutation,  { input: { tocAccepted: true } }));
      logger.debug(`${LOGGER_PREFIX}::acceptTOC result`, result);
      store.dispatch(setUserTOCResults(_.get(result, 'data.setUserInfo'), {}));
      return result;
    } catch (err) {
      logger.error(`${LOGGER_PREFIX}::acceptTOC`, err);
    }
  }
}

export default new UserService();
